import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Customer } from '../../models/customer';
import { CustomerService } from '../services/customer.service';

@Injectable()

/**
 * CustomerResolver resolves request to get all customers
 */
export class CustomersResolver implements Resolve<Customer>
{
	/**
	 * InvoicesResolver constructor
	 *
	 * @param {customerService} CustomerService
	 */
	constructor(private customerService: CustomerService)
	{

	}

	 /**
 	 * Provides data to a route
 	 *
 	 * @returns {Observable<Customer[]>}
 	 */
 	resolve(): Observable<Customer>
 	{
 		return this.customerService.getCustomers();
 	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/resolvers/customers.resolver.ts